import { Directive, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
    selector: '[parseHref]',
    standalone: false
})
export class ParseHrefDirective {

  constructor(
    private readonly router: Router
  ) { }

  @HostListener('click', ['$event']) public onClick(event) {
    let el = event.target;
    while (el.parentNode && el.tagName !== 'A') {
      el = el.parentNode;
    }

    if (el.tagName !== 'A') {
      return;
    }

    const regex = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i;
    const url = el.getAttribute('href');
    const isExternalLink = regex.test(url);
    const targetBlank = el.getAttribute('target') === '_blank';

    if (!isExternalLink && !targetBlank) {
      event.preventDefault();
      this.router.navigateByUrl(url);
    }
  }
}
